import type { CSSObject } from '@ant-design/cssinjs'

// ── 荧光蓝色系 (Neon Blue) ──
export const blue = {
  50: '#e6f4ff',
  100: '#bae0ff',
  200: '#91caff',
  300: '#69b1ff',
  400: '#4096ff',
  500: '#2E81FF',   // 主色：荧光蓝
  600: '#1677ff',
  700: '#0958d9',
  800: '#003eb3',
  900: '#002c8c',
}

// ── 深空蓝背景色系 (Deep Navy) ──
export const navy = {
  950: '#050B14',   // 全局背景 —— 接近纯黑的深蓝
  900: '#0b1624',   // 弹窗/面板实底
  800: '#111d2c',   // 组件底色
  700: '#1E3A5F',   // 默认边框色
  600: '#254670',
  500: '#2d5a8a',
  400: '#3670a5',
}

// ── 半透明容器 (Glass) ──
export const glass = {
  container: 'rgba(17, 29, 44, 0.8)',     // 组件容器
  card: 'rgba(13, 25, 48, 0.75)',          // 卡片
  panel: 'rgba(13, 25, 48, 0.85)',         // 悬浮面板
  header: 'rgba(30, 58, 95, 0.3)',         // 表头
  hover: 'rgba(22, 119, 255, 0.15)',       // 行悬停
  selected: 'rgba(46, 129, 255, 0.2)',     // 选中态
  input: 'rgba(0, 0, 0, 0.2)',            // 输入框
}

// ── 发光阴影 (Glow) ──
export const glowSm = `0 0 6px ${blue[500]}40`
export const glowMd = `0 0 12px ${blue[500]}50, 0 0 4px ${blue[500]}80`
export const glowFocus = `0 0 0 1px ${blue[500]}35, 0 0 4px ${blue[500]}18`

// ── 通用过渡 ──
export const transition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'

// ── 磨砂玻璃效果 ──
export const getGlassStyle = (): CSSObject => ({
  backdropFilter: 'blur(12px) saturate(160%)',
  WebkitBackdropFilter: 'blur(12px) saturate(160%)',
  background: glass.panel,
})

// ── 荧光边框 ──
export const getNeonBorder = (): CSSObject => ({
  border: `1px solid ${navy[700]}`,
})

// ── 激活态发光边框 ──
export const getActiveBorder = (): CSSObject => ({
  borderColor: `${blue[500]} !important`,
  boxShadow: glowFocus,
})
